import { Settings } from "../../settings/settings";

/**
 * Each node using DA-SW possesses a number of
 * abaci, which play the role of lookup table. For a given couple
 * of node degree and targeted average delay, an abacus
 * provides the right number of copies to be sent.
 */
export class Abacus {

    private resultsTable: Array<number> = [];

    private avgDelay: number = -1;

    constructor(protected settings: Settings, 
                public nodeDegree: number = 0, 
                public numCopies: number = 0) { }


    /**
     * Improve the accuracy of the abacus by adding new data.
     */
    addData(avgDelay: number|null): void {
        if(avgDelay != null) {
            this.resultsTable.push(avgDelay);
        }
    }


    calculateValues() {
        let totalDelay = 0;
        this.resultsTable.forEach((result: number) => {
            totalDelay += result; 
        });

        this.avgDelay = totalDelay / this.resultsTable.length;
    }


    /**
     * Take in the node degree and the targeted average delay, and return
     * the number of copies that should be made.
     * @return avgDelay - Recommended number of copies to send 
     */
    getAvgDelay(): number {
        return this.avgDelay;
    }


}